var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8461 15.3348H10.2743C9.70828 15.3348 9.51841 15.172 9.28303 14.7703L6.47687 9.72207C6.31188 9.43919 6.24116 9.25093 6.24116 9.01422C6.24116 8.91993 6.26408 8.77882 6.33479 8.49627L6.57082 7.50521C6.78295 6.60845 7.01931 6.9149 7.70317 6.63268C8.24562 6.39662 8.78806 5.97787 8.78806 4.77499C8.78806 3.45457 8.10419 2.8934 6.68867 2.8934H4.58929V14.7245C4.58929 15.0633 4.17288 15.3348 3.83406 15.3348H1.68786C1.33594 15.3348 0.988281 15.0529 0.988281 14.7006V0.781973C0.988281 0.442783 1.32547 0.27417 1.66429 0.27417H6.92437C10.5581 0.27417 12.2087 1.87321 12.2087 4.82214C12.2087 7.10971 10.9097 8.12171 9.75574 8.85248L13.1996 14.548C13.5764 15.1373 13.1751 15.3348 12.8461 15.3348Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIcon);
export default __webpack_public_path__ + "static/media/rIcon.bdebd83e.svg";
export { ForwardRef as ReactComponent };